export default[
    {
        path: '/acidentetrabalhor/lista',
        name: 'lista', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/acidentetrabalhor/cadastro/:trabalhador_id',
        name: 'cadastro dados acidente de trabalhor', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/acidentetrabalhor/editar/:id',
        name: 'editar dados acidente de trabalhor', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]